import { ReactNode } from "react";
import { Controller, FieldValues } from "react-hook-form";
import { RadioButtonGroup as PLOSRadioButtonGroup } from "../../RadioButtonGroup";
import { SharedControllerProps } from "../types";

interface RadioButtonGroupProps<
  T extends FieldValues = FieldValues,
> extends SharedControllerProps<T> {
  children: ReactNode;
  id: string;
  hideLabel?: boolean;
}

const RadioButtonGroup = <T extends FieldValues = FieldValues>({
  control,
  name,
  rules,
  children,
  id,
  label,
  hideLabel = false,
  disabled = false,
}: RadioButtonGroupProps<T>) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
      <PLOSRadioButtonGroup
        label={label}
        id={id}
        name={name}
        value={value ?? null}
        onChange={onChange}
        errorMessage={error?.message}
        hideLabel={hideLabel}
        aria-label={label}
        isDisabled={disabled}
      >
        {children}
      </PLOSRadioButtonGroup>
    )}
  />
);

export default RadioButtonGroup;
